import { type Option } from 'payload'

export enum FeaturedTagType {
  ThumbnailPrimary = 'thumbnailPrimary',
  ThumbnailSecondary = 'thumbnailSecondary',
  ThumbnailTertiary = 'thumbnailTertiary',
  List = 'list',
  Categories = 'categories',
}

const featuredTagTypeLabel: Record<FeaturedTagType, string> = {
  [FeaturedTagType.ThumbnailPrimary]: 'Thumbnail Primary',
  [FeaturedTagType.ThumbnailSecondary]: 'Thumbnail Secondary',
  [FeaturedTagType.ThumbnailTertiary]: 'Thumbnail Tertiary',
  [FeaturedTagType.List]: 'List',
  [FeaturedTagType.Categories]: 'Categories',
} as const

export const featuredTagTypeOptions: Option[] = [
  {
    label: featuredTagTypeLabel[FeaturedTagType.ThumbnailPrimary],
    value: FeaturedTagType.ThumbnailPrimary,
  },
  {
    label: featuredTagTypeLabel[FeaturedTagType.ThumbnailSecondary],
    value: FeaturedTagType.ThumbnailSecondary,
  },
  {
    label: featuredTagTypeLabel[FeaturedTagType.ThumbnailTertiary],
    value: FeaturedTagType.ThumbnailTertiary,
  },
  {
    label: featuredTagTypeLabel[FeaturedTagType.List],
    value: FeaturedTagType.List,
  },
  {
    label: featuredTagTypeLabel[FeaturedTagType.Categories],
    value: FeaturedTagType.Categories,
  },
] as const satisfies Option[]

export enum PageWidthType {
  Full = 'full',
  Half = 'half',
}

const pageWidthLabel: Record<PageWidthType, string> = {
  [PageWidthType.Full]: 'Full',
  [PageWidthType.Half]: 'Half',
} as const

export const pageWidthOptions: Option[] = [
  {
    label: pageWidthLabel[PageWidthType.Full],
    value: PageWidthType.Full,
  },
  {
    label: pageWidthLabel[PageWidthType.Half],
    value: PageWidthType.Half,
  },
] as const satisfies Option[]

export const allowedPageWidthBySectionType: Record<FeaturedTagType, PageWidthType[]> = {
  [FeaturedTagType.Categories]: [PageWidthType.Full],
  [FeaturedTagType.List]: [PageWidthType.Half],
  [FeaturedTagType.ThumbnailPrimary]: [PageWidthType.Full],
  [FeaturedTagType.ThumbnailSecondary]: [PageWidthType.Full],
  [FeaturedTagType.ThumbnailTertiary]: [PageWidthType.Full],
} as const
